(() => {
  if (window.okgGeorgeWordsInitialized) return;
  window.okgGeorgeWordsInitialized = true;

  const clamp = (value) => Math.min(1, Math.max(0, value));
  const initialize = (heading) => {
    const isGeorge = heading.hasAttribute('data-okg-george-words');
    const banner = heading.closest(
      isGeorge ? "[id*='__george_heritage_banner']" : "[id*='__garen_legacy_banner']"
    );
    const media = banner?.querySelector('.banner__media');
    if (!banner) return;

    heading.textContent = '';

    const phrases = isGeorge
      ? ['Before OKG,', 'There Was', 'a Dream.']
      : ['Then, the Dream', 'Became a Legacy.'];
    const phraseClass = isGeorge ? 'okg-george-phrase' : 'okg-garen-phrase';
    const phraseElements = phrases.map((phrase, index) => {
      const element = document.createElement('span');
      element.className = phraseClass;
      element.textContent = phrase;
      heading.append(element);

      if (index < phrases.length - 1) heading.append(document.createElement('br'));

      return element;
    });

    let ticking = false;
    const update = () => {
      ticking = false;
      const viewportHeight = window.innerHeight;
      const headingTop = heading.getBoundingClientRect().top;
      const progress = isGeorge
        ? clamp((viewportHeight * 0.47 - headingTop) / (viewportHeight * 0.42))
        : clamp((viewportHeight - headingTop) / (viewportHeight * 0.85));

      const phraseStarts = isGeorge ? [0, 0.36, 0.7] : [0, 0.48];
      phraseElements.forEach((phrase, index) => {
        const localProgress = clamp((progress - phraseStarts[index]) / 0.28);

        phrase.style.opacity = String(localProgress);
      });

      if (media) {
        const bannerBounds = banner.getBoundingClientRect();
        const photoProgress = clamp(-bannerBounds.top / banner.offsetHeight);
        media.style.setProperty(
          '--okg-george-photo-parallax',
          `${Math.round(banner.offsetHeight * 0.3 * photoProgress)}px`
        );
      }
    };

    const requestUpdate = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    };

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    requestUpdate();
  };

  document.querySelectorAll('[data-okg-george-words], [data-okg-garen-words]').forEach(initialize);
})();
